// antd
import { Modal } from 'antd';

import './confirm.scss';
import { ReactNode } from 'react';

const { confirm } = Modal;


type ConfirmParams = {
 title: string
 icon?: ReactNode
 content: ReactNode
 onOk:() => void
 onCancel?: () => void
 cancelText?:string
 okText?:string
 className: string
}

const Confirm = ({ title, icon, content, onOk, onCancel, cancelText = "Cancel", okText = "Ok", className }:ConfirmParams) => {
    confirm({
        title,
        icon,
        content,
        onOk() {
            onOk();
        },
        closable: true,
        onCancel() {
            if (onCancel) {
                onCancel();
            }
        },
        cancelText,
        okText,
        className: 'confirmation' + ` ${className}`,
    });
};

export { Confirm };
